<template>
  <a-list
    class="list"
    :loading="loading"
    itemLayout="horizontal"
    :dataSource="results"
  >
    <list-cols-header
      slot="header"
      :headers="headers"
      :actions-cols="0"
      :col-spans="[4, 5, 7, 4, 4]"
    />
    <a-list-item slot="renderItem" slot-scope="item">
      <a-row type="flex" class="item-row" :gutter="24">
        <a-col span="4">
          <a-list-item-meta>
            <span slot="title">
              <span
                v-if="fieldEdited.pk === item.id && fieldEdited.name === 'name'"
              >
                <a-input v-model="fieldEdited.value">
                  <a-icon
                    slot="suffix"
                    type="check-circle"
                    @click="submitField()"
                  />
                </a-input>
              </span>
              <span v-else>
                {{ item.name }}
                <a-icon
                  v-if="!readOnly"
                  type="edit"
                  class="edit-icon"
                  @click="editField(item, 'name')"
                />
              </span>
            </span>
          </a-list-item-meta>
        </a-col>

        <a-col span="5">
          <a-list-item-meta>
            <span slot="title">
              <span
                v-if="
                  fieldEdited.pk === item.id && fieldEdited.name === 'deadline'
                "
              >
                <date-picker v-model="fieldEdited.value" />
                <a-icon
                  slot="suffix"
                  type="check-circle"
                  @click="submitField()"
                />
              </span>
              <span v-else>
                {{ item.deadline }}
                <a-icon
                  v-if="!readOnly"
                  type="edit"
                  class="edit-icon"
                  @click="editField(item, 'deadline')"
                />
              </span>
            </span>
          </a-list-item-meta>
        </a-col>

        <a-col span="7">
          <a-list-item-meta>
            <span slot="title">
              <span
                v-if="
                  fieldEdited.pk === item.id && fieldEdited.name === 'amount'
                "
              >
                <a-input v-model="fieldEdited.value">
                  <a-icon
                    slot="suffix"
                    type="check-circle"
                    @click="submitField()"
                  />
                </a-input>
              </span>
              <span v-else>
                {{ item.amount }} zł
                <a-icon
                  v-if="!readOnly"
                  type="edit"
                  class="edit-icon"
                  @click="editField(item, 'amount')"
                />
              </span>
            </span>
          </a-list-item-meta>
        </a-col>

        <a-col span="4">
          <a-list-item-meta>
            <span slot="title">
              <uploaded-file
                v-if="item.invoice"
                title="Faktura"
                :link="item.invoice"
                :removable="isAdmin"
                @remove="removeInvoice(item)"
              />
              <label v-if="!item.invoice">
                <input
                  v-if="!item.invoice"
                  type="file"
                  id="file"
                  @change="uploadInvoice(item, $event.target.files)"
                  class="input-file"
                />
                <span v-if="!readOnly" class="input-label">Załącz fakturę</span>
              </label>
            </span>
          </a-list-item-meta>
        </a-col>

        <a-col span="4">
          <a-list-item-meta v-if="!readOnly">
            <span slot="title">
              <a-checkbox
                :checked="item.is_paid"
                @change="switchIsPaid(item)"
              />
            </span>
          </a-list-item-meta>
          <a-list-item-meta v-else>
            <template slot="title">
              <a-tag :color="tagColor(item.is_paid)"
                >{{ item.is_paid ? 'Zapłacone' : 'Niezapłacone' }}
              </a-tag>
            </template>
          </a-list-item-meta>
        </a-col>
      </a-row>
    </a-list-item>
  </a-list>
</template>

<script>
import { CoursePayment } from '@/api'
import UploadedFile from '@/components/common/UploadedFile'

export default {
  components: {
    UploadedFile
  },
  props: {
    results: Array,
    loading: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      headers: ['Nazwa', 'Termin płatności', 'Kwota', 'Faktura', 'Zapłacone'],
      fieldEdited: {
        name: '',
        value: null,
        pk: null
      }
    }
  },
  methods: {
    submitField() {
      CoursePayment.patch(this.fieldEdited.pk, {
        [this.fieldEdited.name]: this.fieldEdited.value
      })
        .then(() => {
          this.$emit('listUpdated')
          this.fieldEdited = {
            name: '',
            value: null,
            pk: null
          }
          this.$notification.success({ message: 'Zapisano' })
        })
        .catch(() => {
          this.$notification.error({ message: 'Nie udało się zapisać zmian' })
        })
    },
    editField(instance, name) {
      const value = instance[name]
      this.fieldEdited = {
        name,
        value,
        pk: instance.id
      }
    },
    switchIsPaid(instance) {
      const newValue = !instance.is_paid
      CoursePayment.patch(instance.id, {
        is_paid: newValue
      }).then(() => {
        this.$notification.success({
          message: 'Zmieniono status'
        })
        this.$emit('listUpdated')
      })
    },
    uploadInvoice(instance, files) {
      const file = files[0]

      CoursePayment.patchMultipart(instance.id, {
        invoice: file
      }).then(() => {
        this.$notification.success({
          message: 'Wgrano fakturę'
        })
        this.$emit('listUpdated')
      })
    },
    removeInvoice(instance) {
      CoursePayment.patchMultipart(instance.id, {
        invoice: ''
      }).then(() => {
        this.$notification.success({
          message: 'Usunięto fakturę'
        })
        this.$emit('listUpdated')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.input-file {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

.input-label {
  color: #1890ff;
  cursor: pointer;
}

.item-row {
  flex: 1;
  width: 100%;
}

.edit-icon {
  display: inline-block;
  color: #1890ff;
  font-size: 12px;

  position: relative;
  top: -1.5px;
  padding: 4px;
}
</style>
